export default {
  data() {
    return {
      types: ["normal","distributor"]
    }
  },
  methods: {
    showType(type){
      switch(type) {
        case 'admin':
          return this.$t('Owners.company.types.admin');
        case 'distributor':
          return this.$t('Owners.company.types.distributor');
        case 'normal':
          return this.$t('Owners.company.types.normal');
        default:
          return null;
      }
    }
  }
}
